export default __webpack_public_path__ + "static/media/filter_tr.cf27eb74.svg";